﻿(function ($, document) {

    $(document).ready(function () {

        $(document).on('click', '.js-hook--web-alerts-delete', function (e) {
                console.log(e);
                e.preventDefault();

                $.ajax({
                    url: '/api/WebAlerts/DeleteWebAlertById?id=' + e.currentTarget.dataset.alertId,
                    method: 'POST',
                    contentType: "application/json"
                }).done(function (result) {
                    $(e.currentTarget).parent('.flex-table__row').remove();
                }).error(function (result) {
                    console.log("error deleting web alert");
                    console.log(result);
                });
            });

    });


})(jQuery, document);